// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2Ces_","checkboxCol":"Table_checkboxCol__2LjPc","emailCol":"Table_emailCol__2jyts","actionCol":"Table_actionCol__7qSUj"};